// extracted by mini-css-extract-plugin
export default {"summary":"TaskSyncPage_summary__0QUmp","title":"TaskSyncPage_title__4Ryc5"};